import React, { useState, useEffect } from 'react';
import { DateRange } from '@cyberlz/react-date-range';
import { formatDate } from 'legacyfrontend/utils/dateUtils';

const SingleDatePicker = ({
  selectedDate,
  onChange,
  label,
  error,
  helperText,
  minDate,
  maxDate,
  disabled,
  placeholder,
  className,
  style,
  dateFormat,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleDateSelect = (item) => {
    const { startDate } = item.selection;
    onChange?.(startDate);
    setIsOpen(false);
  };

  const toggleDatePicker = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };

  const handleClickOutside = (event) => {
    if (!event.target.closest('.single-date-picker')) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const ranges = [
    {
      startDate: selectedDate || new Date(),
      endDate: selectedDate || new Date(),
      key: 'selection',
    },
  ];

  return (
    <div className={`single-date-picker relative ${className || ''}`} style={style}>
      {label && <label className='block text-gray-700 text-sm font-bold mb-2'>{label}</label>}

      <div
        className={`
          shadow-sm border border-gray-300 rounded-md w-full py-3 px-4 text-gray-700 leading-tight 
          focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:border-transparent
          cursor-pointer flex items-center justify-between
          ${error ? 'border-red-500' : ''}
          ${disabled ? 'bg-gray-100 cursor-not-allowed' : 'bg-white hover:border-gray-400'}
        `}
        onClick={toggleDatePicker}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            toggleDatePicker();
          }
        }}
        role='button'
        tabIndex={0}
      >
        <span className={`flex-1 ${selectedDate ? 'text-gray-700' : 'text-gray-400'}`}>
          {selectedDate ? formatDate(selectedDate, dateFormat) : placeholder || 'Seleccionar fecha'}
        </span>
        <i className='fa fa-calendar text-gray-500 ml-2'></i>
      </div>

      {isOpen && (
        <div className='absolute top-full left-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg z-50 p-2'>
          <DateRange
            direction='horizontal'
            maxDate={maxDate}
            minDate={minDate}
            months={1}
            moveRangeOnFirstSelection={false}
            onChange={handleDateSelect}
            rangeColors={['#dc2626']}
            ranges={ranges}
            showDateDisplay={false}
            showMonthAndYearPickers
            showPreview
          />
        </div>
      )}

      {error && <div className='text-red-500 text-sm mt-1'>{error}</div>}
      {helperText && !error && <div className='text-gray-500 text-sm mt-1'>{helperText}</div>}
    </div>
  );
};

export default SingleDatePicker;
